import React from "react";

export default function LogoIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor" clipPath="url(#a)">
        <path d="M16.5 9.082a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z" />
        <path
          fillRule="evenodd"
          d="M0 12.082a12 12 0 1 1 24 0 12 12 0 0 1-24 0Zm12-10.5a10.5 10.5 0 0 0-8.202 17.055c1.065-1.716 3.41-3.555 8.202-3.555 4.793 0 7.136 1.837 8.202 3.555A10.5 10.5 0 0 0 12 1.582Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .082h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
